import BaseModel from '../../base';

import Tournament from '../index';

export default class TournamentStage extends BaseModel {
  constructor(stage = {}, url) {
    super(stage, url);

    this.name = stage.name || '';
    this.description = stage.description || '';

    this.tournament_id = stage.tournament_id;
    this.tournament = new Tournament(stage.tournament || {}, 'tournament');

    this.parent_id = stage.parent_id;

    this.groups = stage.groups || [];
  }
}
